import React from 'react';
import { IonIcon, IonText } from "@ionic/react";
import {
    briefcaseOutline,
    mailOutline,
    documentOutline,
    calendarOutline
} from "ionicons/icons";

import moment from 'moment-timezone';
import {callFunctionToDownload} from "../lib/downloadHelper";

export default function AssignmentDetail({ assignmentDetail }) {
    return (
        <div className="job_detail_common_page" data-publisher-content="true">
            {/* Basic Job Info */}
            <div className="rfp-card in_detail_panel">
                <div className="rfp-card-left">
                    <div className="rfp-card-detail-price_menu">
                        <h4>
                            {assignmentDetail.title}
                        </h4>
                        <div>
                            <div className="rfp-price">₹{assignmentDetail.price}</div>
                            <div className="rfp-min">Min. price</div>
                        </div>
                    </div>
                    <div className="rfp-details">
                        <span className="rfp-location"><IonIcon icon={briefcaseOutline}/> {assignmentDetail.location}</span>
                        <span className="rfp-days"><IonIcon icon={mailOutline}/> {assignmentDetail.email}</span>
                        <span className="rfp-days"><IonIcon icon={calendarOutline}/>
                            {
                                (() => {
                                    const daysLeft = moment(assignmentDetail.expiry_date).startOf('day').diff(moment().startOf('day'), 'days');
                                    return daysLeft < 0
                                        ? 'Expired'
                                        : `${daysLeft} Day${daysLeft !== 1 ? 's' : ''} Left`;
                                })()
                            }
                        </span>
                    </div>
                </div>
            </div>

            {/* Job Description */}
            <div className="job-description">
                <IonText><h6>Scope of Work</h6></IonText>
                <p>{assignmentDetail.scope_of_work}</p>
            </div>

            <div className="job-key-responsiblities">
                <IonText><h6>Attachment:</h6></IonText>
                <ul>
                    <li>
                        {assignmentDetail.attched_pdf_url ? (
                            <>
                                <IonIcon icon={documentOutline}/>{" "}
                                <a onClick={()=>callFunctionToDownload(assignmentDetail.attched_pdf_url)} rel="noopener noreferrer">
                                    Download PDF
                                </a>
                            </>
                        ) : (
                            "No attachment"
                        )}
                    </li>
                </ul>
            </div>

            <div className="job-requirement">
                <IonText><h6>Contact:</h6></IonText>
                <ul>
                    <li>
                        <IonIcon icon={mailOutline}/> {assignmentDetail.email}
                    </li>
                </ul>
            </div>
        </div>
    );
}
